import { keepPreviousData, useQuery } from '@tanstack/react-query'
import {
  getCompanyValuationHistory,
  type ValuationHistoryRange,
} from '@/services/companies.service'

export function useCompanyValuationHistory(
  companyId: string,
  range: ValuationHistoryRange = 'LTM'
) {
  return useQuery({
    queryKey: ['company-valuation-history', companyId, range],
    queryFn: () => getCompanyValuationHistory(companyId, { range }),
    enabled: Boolean(companyId),
    placeholderData: keepPreviousData,
    staleTime: 5 * 60 * 1000,
  })
}
